import { render, staticRenderFns } from "./BindProduct.vue?vue&type=template&id=49f16d20&scoped=true"
import script from "./BindProduct.vue?vue&type=script&lang=js"
export * from "./BindProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f16d20",
  null
  
)

export default component.exports